import React from 'react';
import { IconType } from 'react-icons';
import {
  FaBullhorn,
  FaChartColumn,
  FaChartLine,
  FaHandshake,
  FaRegComments,
  FaRegFileLines,
  FaRegNewspaper,
} from 'react-icons/fa6';
import type { ArticleCategory } from './article-category';

const CATEGORY_ICONS: Record<ArticleCategory, IconType> = {
  Article: FaRegFileLines,
  Earnings: FaChartColumn,
  'M&A': FaHandshake,
  Markets: FaChartLine,
  News: FaRegNewspaper,
  Opinion: FaRegComments,
  PR: FaBullhorn,
};

export const CategoryIcon: React.FC<{ category: ArticleCategory; className?: string }> = ({ category, className }) => {
  const Icon = CATEGORY_ICONS[category] ?? CATEGORY_ICONS.Article;
  return (
    <span aria-hidden className={className}>
      <Icon size="1em" />
    </span>
  );
};
